import {Component, Inject, OnInit} from '@angular/core';
import {switchMap} from 'rxjs/internal/operators';
import {interval, merge, timer} from 'rxjs';
import {concatMap, takeWhile, tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {DigitalSignatureService} from '../service/digital-signature.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MESSAGES} from '../util/message';

@Component({
  selector: 'app-digital-signature-rectangle-dialog',
  templateUrl: './digital-signature-rectangle-dialog.component.html',
  styleUrls: ['./digital-signature-rectangle-dialog.component.scss']
})
export class DigitalSignatureRectangleDialogComponent implements OnInit {


  appTitle = MESSAGES.APP_TITLE;
  openDesktopApp = MESSAGES.OPEN_DESKTOP_APP;
  desktopAppWarning = MESSAGES.DESKTOP_APP_WARNING;
  document = MESSAGES.DOCUMENT;
  saveDocument = MESSAGES.SAVE_DOCUMENT;
  beginSigning = MESSAGES.BEGIN_SIGNING;
  selectCertificate = MESSAGES.SELECT_CERTIFICATE;
  insertPassword = MESSAGES.INSERT_PASSWORD;
  signDocumentMessage = MESSAGES.SIGN_DOCUMENT;
  signatureId: string | undefined;
  // todo: get from local storage
  email: string;
  // email = 'adriana.popa@csm.ro';
  receivedAliases = false;
  documentSigned = false;
  aliases: string[] = [];
  receivedAliasLoader = false;
  selectedAlias?: string;
  public isLoading = false;
  public safePdfUrl?: SafeResourceUrl;
  password?: string;
  documentUUID?: string | null;
  fileName?: string | null;
  openDesktopAppAdvise = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<DigitalSignatureRectangleDialogComponent>,
    private router: Router,
    private sanitizer: DomSanitizer,
    private digitalSignatureService: DigitalSignatureService) {
  }

  ngOnInit(): void {
    this.documentUUID = this.data.documentUUID;
    this.fileName = this.data.fileName;
    const userProfile = JSON.parse(localStorage.getItem('userProfile') || '{}');
    this.email = userProfile.username;
    // only for debug purpose
    // console.log('Data este: ', this.data);
    // console.log(this.documentUUID);
    // console.log(this.fileName);
  }


  initializeSignature(): void {
    this.receivedAliasLoader = true;
    this.digitalSignatureService.saveSignature(this.email).pipe(
      concatMap((response: any) => {
        const signatureId = response.id;
        this.signatureId = signatureId;
        // only for debug purpose
        // console.log('Signature saved successfully:', response);

        const adviseObservable = timer(20000).pipe(
          tap(() => {
            this.openDesktopAppAdvise = true;
          })
        );

        const pollingObservable = interval(1000).pipe(
          switchMap(() => this.digitalSignatureService.getAliases(signatureId)),
          takeWhile((aliases: string[]) => aliases.length === 0, true)
        );

        return merge(pollingObservable, adviseObservable);
      })
    ).subscribe(
      (aliases: any) => {
        if (aliases && aliases.length > 0) {
          // only for debug purpose
          // console.log('Received Document ID:', aliases);
          this.aliases = aliases;
          this.receivedAliasLoader = false;
          this.receivedAliases = true;
          this.openDesktopAppAdvise = false;
        } else if (aliases) {
          // only for debug purpose
          // console.log('Received Document ID:', aliases);
        }
      },
      (error) => {
        console.error('Error:', error);
      }
    );
  }


  signDocument(): void {
    this.isLoading = true;
    let sigId = '';
    let selectAlias = '';
    if (this.selectedAlias && this.password && this.signatureId) {
      sigId = this.signatureId;
      selectAlias = this.selectedAlias;
      this.digitalSignatureService.savePassword(this.signatureId, this.password).pipe(
        switchMap(() => {
          return this.digitalSignatureService.updateAlias(sigId, selectAlias);
        })
      ).subscribe(
        response => {
          if (this.signatureId && this.documentUUID) {
            // only for debug purpose
            // console.log('Ambele requesturi au fost efectuate cu succes!');
            this.startPollingForCertificate(this.signatureId, this.documentUUID);
          }

        },
        error => {
          // todo: add error advise and some redirect
          console.error('A apărut o eroare!', error);
        }
      );
    }
  }

  startPollingForCertificate(signatureId: string, documentUUID: string): void {
    const POLLING_INTERVAL = 1000;

    interval(POLLING_INTERVAL).pipe(
      switchMap(() => this.digitalSignatureService.getCertificate(signatureId)),
      takeWhile((response: string) => response !== 'founded', true)
    ).subscribe(
      response => {
        if (response === 'founded') {
          // only for debug purpose
          //  console.log('Răspunsul \'founded\' a fost primit!');
          const requestBody = {
            startX: this.data.startX,
            startY: this.data.startY,
            pageHeight: this.data.pageHeight,
            pageWidth: this.data.pageWidth,
            page: this.data.page,
            signatureId,
            documentUUID
          };
          // only for debug purpose
          console.log('Urmatorul requestBody a fost trimis catre be: ', requestBody);
          this.getPdfSignedUUID(requestBody);
        } else {
          // only for debug purpose
          console.log('Răspuns primit, dar nu este \'founded\'. Continuăm polling-ul.');
        }
      },
      error => {
        // todo: add error advise and some redirect
        console.error('A apărut o eroare în timpul polling-ului.', error);
      }
    );
  }

  getPdfSignedUUID(requestBody: any) {
    this.digitalSignatureService.getSignedDocumentUUID(requestBody).subscribe((response: any) => {
      this.isLoading = false;
      // only for debug purpose
      console.log('S-a primit documentul semnat: ', response);
      console.log('Documentul semnat UUID: ', response.signedDocumentUUID);
      if (response && response.signedDocumentUUID) {
        const documentSignedUUID = response.signedDocumentUUID;
        console.log('documentSignedUUID', documentSignedUUID);
        this.dialogRef.close(documentSignedUUID);
      } else {
        this.dialogRef.close();
      }
    }, error => {
      // todo: add error advise and some redirect
      console.error('There was an error:', error);
    });
  }

  goToPdfSigned(documentUUID: string) {
    this.router.navigateByUrl(`/semnatura/get-signed-document/${documentUUID}`);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  downloadDocument() {
    if (this.documentUUID && this.fileName) {
      this.digitalSignatureService.getDocumentThatWillBeSigned(this.documentUUID).subscribe(data => {
        const blob = new Blob([data], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);

        const anchor = document.createElement('a');
        if (typeof this.fileName === 'string') {
          anchor.download = this.fileName;
        }
        anchor.href = url;
        anchor.click();

        window.URL.revokeObjectURL(url);
      });
    }
  }

}
